import { useEffect, useState } from "react";
import Api from "../../services/Api";
import { createClient } from "../../services/Utility";
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import RopaForm from "./RopaForm";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import moment from "moment";
import "../dashboard/Dashboard.css"
import Spinner from "../../components/Spinner";
import PrintForm from "./PrintForm";
import { CheckIcon } from "@heroicons/react/24/outline";

// import Select from "react-dropdown-select";
let fieldsState = {};

const sma = [
  { value: true, label: "True" },
  { value: false, label: "False" },
]

function CreateForm(props) {
  const [formdatas, setFormDatas] = useState([])
  const [tenantdatas, setTenantDatas] = useState([])
  const [selectedFile, setSelectedFile] = useState();
  const [selectedForm, setSelectedForm] = useState();
  const [updateFile, setUpdateFile] = useState();
  const [logourl, setLogourl] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [fileId, setFileId] = useState();
  const [formState, setFormState] = useState(fieldsState);
  const [errorMessage, setErrorMessage] = useState("")
  const [showError, setShowError] = useState(false)
  const [selectedOPtion, setOPtion] = useState(null)
  const [selectedTenant, setTenantOption] = useState(null)
  const [selectedOPtionSma, setOPtionSma] = useState(null)
  const [isEdit, setIsEdit] = useState(true)
  const [isLoading, setLoading] = useState(false)

  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleChange = (e, type = "text") => {
    setFormState({
      ...formState, [e.target.id]: type == "date" ? e.target.value + "T00:00:00.000Z" :
        type == "number" ? Number(e.target.value) :
          e.target.value
    })
  }

  const navigate = useNavigate()

  const handleUploadClick = async (event) => {
    var file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    setSelectedFile(event.target.files[0])
    const data = await Api.uploadFile(event.target.files[0]);
    if (data) {
      setFormState({ ...formState, logo_url: data.url })
      setLogourl(data.url)
    }



  };
  useEffect(() => {
    getTableData()
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get("id")
    if (id) {
      setIsUpdate(true)
      getSingleFile(id)
      setFileId(id)
    }


  }, [])

  const getTableData = async () => {
    const data = await Api.getTableData("projects");
    if (data) {

      const projectData = data.data.data.results.map(item => {
        const obj = {
          value: item.id,
          label: item.name
        }
        return obj;
      })

      setFormDatas(projectData)
    }
    if (props.type == "Data Subject Types" || props.type == "Users") {
      const dataTenant = await Api.getTableData("tenants");
      const tenantData = dataTenant.data.data.results.map(item => {
        const obj = {
          value: item.id,
          label: item.name
        }
        return obj;
      })

      setTenantDatas(tenantData)


    }
  }

  useEffect(() => {
    if (props.type == "Users") {
      setTenantOption(
        {
          label: tenantdatas.find(item => item.value == formState?.tenant_id)?.label,
          value: tenantdatas.find(item => item.value == formState?.tenant_id)?.value
        }
      )
    }

  }, [formState, tenantdatas])
  const getSingleFile = async (id) => {
    setLoading(true)
    const dataSingle = await Api.getSingleFile(id, props.createUrl, localStorage.getItem('DP_PROJECT_ID') ? localStorage.getItem('DP_PROJECT_ID') : null);
    setLoading(false)
    if (dataSingle) {
      setSelectedForm(dataSingle.data)
      setUpdateFile(dataSingle.data.logo_url)
      if (props.type == "Request Types") {
        setFormState({
          ...formState, name: dataSingle.data.name,
          project_id: dataSingle.data.project_id,
          tenant_id: dataSingle.data.tenant_id,
          trigger_api_method: dataSingle.data.trigger_api_method,
          trigger_api_params: dataSingle.data.trigger_api_params,
          trigger_api_url: dataSingle.data.trigger_api_url
        })
        setOPtion(
          {
            label: dataSingle.data.project.name,
            value: dataSingle.data.project.id
          }
        )
      }
      else if (props.type == "Data Subject Types") {
        setFormState({
          ...formState, name: dataSingle.data.name,
          project_id: dataSingle.data.project_id,
          tenant_id: dataSingle.data.tenant_id,
          has_msa: dataSingle.data.has_msa,
          dp_handle: dataSingle.data.dp_handle,

          email_domains: dataSingle.data.trigger_api_url
        })
        setTenantOption(
          {
            label: dataSingle.data.tenant.name,
            value: dataSingle.data.tenant.id
          }
        )
        setOPtion(
          {
            label: dataSingle.data.project.name,
            value: dataSingle.data.project.id
          }
        )
      }
      else if (props.type == "Projects")
        setFormState({
          ...formState, name: dataSingle.data.name,
          project_id: dataSingle.data.project_id,
          tenant_id: dataSingle.data.tenant_id,
          email_from: dataSingle.data.email_from,
          dp_handle: dataSingle.data.dp_handle,
          contract_value: dataSingle.data.contract_value,
          start_date: dataSingle.data.start_date,
          msa_signed_on: dataSingle.data.msa_signed_on,
          end_date: dataSingle.data.end_date,
          email_cc: dataSingle.data.email_cc
        })
      else if (props.type == "Clients" || props.type == "Tenants") {
        setFormState({
          ...formState, name: dataSingle.data.name,
          dp_handle: dataSingle.data.dp_handle,
          email_domains: dataSingle.data.email_domains,
          has_msa: dataSingle.data.has_msa,
        })
        setOPtionSma({
          label: dataSingle.data.has_msa + "",
          value: dataSingle.data.has_msa
        }
        )
      }
      else if (props.type == "Privacy Policies")
        setFormState({
          ...formState, privacy_policy_text: dataSingle.data.privacy_policy_text,
          privacy_policy_url: dataSingle.data.privacy_policy_url,
          language_code: dataSingle.data.language_code,
          privacy_policy_date: dataSingle.data.privacy_policy_date,
          project_id: dataSingle.data.project_id,
          privacy_policy_version: dataSingle.data.privacy_policy_version,
        })
      else if (props.type == "Terms Of Use")
        setFormState({
          ...formState, terms_of_use_text: dataSingle.data.terms_of_use_text,
          terms_of_use_url: dataSingle.data.terms_of_use_url,
          language_code: dataSingle.data.language_code,
          terms_of_use_date: dataSingle.data.terms_of_use_date,
          project_id: dataSingle.data.project_id,
          terms_of_use_version: dataSingle.data.terms_of_use_version,
        })
      else if (props.type == "Users") {
        setFormState({
          ...formState, email_address: dataSingle.data.email_address,
          name: dataSingle.data.name,
          tenant_id: dataSingle.data.tenant_id,

        })

      }
      else if (props.type == "ROPA") {
        setFormState({
          ...formState,
          "project_id": {
            label: dataSingle.data.project.name,
            value: dataSingle.data.project_id
          },
          "name": dataSingle.data.name,
          "business_function": dataSingle.data.business_function ? dataSingle.data.business_function.indexOf(', ') !== -1 ?
            dataSingle.data.business_function.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.business_function,
              value: dataSingle.data.business_function
            }
            :
            null,
          "purpose": dataSingle.data.purpose ? dataSingle.data.purpose.indexOf(', ') !== -1 ?
            dataSingle.data.purpose.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.purpose,
              value: dataSingle.data.purpose
            }
            :
            null,
          "tenant_role": dataSingle.data.tenant_role ? dataSingle.data.tenant_role.indexOf(', ') !== -1 ?
            dataSingle.data.tenant_role.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.tenant_role,
              value: dataSingle.data.tenant_role
            }
            :
            null,
          "r2_role": dataSingle.data.r2_role ? dataSingle.data.r2_role.indexOf(', ') !== -1 ?
            dataSingle.data.r2_role.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.r2_role,
              value: dataSingle.data.r2_role
            }
            :
            null,
          "individual_categories": dataSingle.data.individual_categories ? dataSingle.data.individual_categories.indexOf(', ') !== -1 ?
            dataSingle.data.individual_categories.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.individual_categories,
              value: dataSingle.data.individual_categories
            }
            :
            null,
          "personal_data_categories": dataSingle.data.personal_data_categories ? dataSingle.data.personal_data_categories.indexOf(', ') !== -1 ?
            dataSingle.data.personal_data_categories.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.personal_data_categories,
              value: dataSingle.data.personal_data_categories
            }
            :
            null,
          "legal_reason": dataSingle.data.legal_reason ? dataSingle.data.legal_reason.indexOf(', ') !== -1 ?
            dataSingle.data.legal_reason.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.legal_reason,
              value: dataSingle.data.legal_reason
            }
            :
            null,
          "allow_international_data_transfers": {
            label: dataSingle.data.allow_international_data_transfers === true || dataSingle.data.allow_international_data_transfers === "true" ? "Yes" : "No",
            value: dataSingle.data.allow_international_data_transfers
          },
          "international_data_transfer_safeguards": dataSingle.data.international_data_transfer_safeguards ? dataSingle.data.international_data_transfer_safeguards.indexOf(', ') !== -1 ?
            dataSingle.data.international_data_transfer_safeguards.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.international_data_transfer_safeguards,
              value: dataSingle.data.international_data_transfer_safeguards
            }
            :
            null,
          "external_recipients_with_access": dataSingle.data.external_recipients_with_access ? dataSingle.data.external_recipients_with_access.indexOf(', ') !== -1 ?
            dataSingle.data.external_recipients_with_access.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.external_recipients_with_access,
              value: dataSingle.data.external_recipients_with_access
            }
            :
            null,
          "is_retention_schedule_defined": {
            label: dataSingle.data.is_retention_schedule_defined === true || dataSingle.data.is_retention_schedule_defined === "true" ? "Yes" : "No",
            value: dataSingle.data.is_retention_schedule_defined
          },
          "security_measures": dataSingle.data.security_measures ? dataSingle.data.security_measures.indexOf(', ') !== -1 ?
            dataSingle.data.security_measures.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.security_measures,
              value: dataSingle.data.security_measures
            }
            :
            null,
          criminal_data_categories: dataSingle.data.criminal_data_categories ? dataSingle.data.criminal_data_categories.indexOf(', ') !== -1 ?
            dataSingle.data.criminal_data_categories.split(', ').map(v => ({
              label: v,
              value: v
            }))
            :
            {
              label: dataSingle.data.criminal_data_categories,
              value: dataSingle.data.criminal_data_categories
            }
            :
            null,
          assigned_to_id: {
            label: dataSingle.data.tenant?.name,
            value: dataSingle.data.assigned_to_id
          },
          review_date: dataSingle.data.review_date,
          data_types: {
            label: dataSingle.data.data_types,
            value: dataSingle.data.data_types
          },
          status: {
            label: dataSingle.data.status,
            value: dataSingle.data.status
          },

          "first_name": dataSingle.data.data_privacy_officer?.first_name,
          "last_name": dataSingle.data.data_privacy_officer?.last_name,
          "address": dataSingle.data.data_privacy_officer?.address,
          "city": dataSingle.data.data_privacy_officer?.city,
          "zip_code": dataSingle.data.data_privacy_officer?.zip_code,
          "country": dataSingle.data.data_privacy_officer?.country,
          "phone_number": dataSingle.data.data_privacy_officer?.phone_number,
          "email_address": dataSingle.data.data_privacy_officer?.email_address



        })
      }
      else if (props.type == "DSAR Requests")
        setFormState({
          ...formState, created_at: dataSingle.data.created_at,
          first_name: dataSingle.data.first_name,
          email_address: dataSingle.data.email_address,
          phone_number: dataSingle.data.phone_number,
          description: dataSingle.data.description,
          request_validated: {
            label: dataSingle.data.request_validated === true || dataSingle.data.request_validated === "true" ? "Yes" : "No",
            value: dataSingle.data.request_validated
          },
          request_responded: {
            label: dataSingle.data.request_responded === true || dataSingle.data.request_responded === "true" ? "Yes" : "No",
            value: dataSingle.data.request_responded
          },
          response_date: dataSingle.data.response_date,
          status: {
            label: dataSingle.data.status,
            value: dataSingle.data.status
          },
        })

    }
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true)
    var payload = {}
    if (props.type == "DSAR Requests") {
      payload = {
        request_validated: formState.request_validated?.value,
        request_responded: formState.request_responded?.value,
        response_date: formState.response_date ? formState.response_date : null,
        status: formState.status?.value
      }
    }

    else {
      payload = formState
      if (props.type == "Users" && isUpdate)
        delete payload.name
    }


    const dataSubmit = isUpdate ? await Api.updateFile(payload, props.createUrl, fileId) :
      await Api.createFile(formState, props.createUrl);
    setLoading(false)
    if (dataSubmit?.err == true) {
      setShowError(true)
      setErrorMessage(dataSubmit.msg)
    }
    else {
      alert(dataSubmit?.msg)

      navigate(`/dashboard/${props.backLink}`)
    }
  }
  const scuccessRes = (dataSubmit) => {
    if (dataSubmit?.err) {
      setShowError(true)
      setErrorMessage(dataSubmit.msg)
    }
    else {
      alert(isUpdate ? "Successfully Updated" : "Successfully Created")

      navigate(`/dashboard/${props.backLink}`)

    }
  }
  // reference by form input's `name` tag



  // useEffect(()=>{console.log("raseem", JSON.stringify(formState))},[formState])
  const handleChangeSelect = (value, name, api = false) => {
    if (api) {
      if (name == "tenant_id")
        setTenantOption()
      else
        setOPtion(value)
    }
    else {
      setOPtionSma(value)
    }
    if (props.type == "DSAR Requests")
      setFormState({ ...formState, [name]: value })
    else
      setFormState({ ...formState, [name]: value.value })
  }

  // useEffect(()=>{
  //   if(formState)
  //   {
  //     if(props.type == "Users")
  //     setOPtion(formdatas.filter(item=>item.value==formState.tenant_id))
  //     else
  //     setOPtion(formdatas.filter(item=>item.value==formState.project_id))
  //   }
  // },[formState,formdatas])
  const printDocument = () => {
    setModalOpen(true);
    // const input = document.getElementById('divToPrint');
    // html2canvas(input)
    //   .then((canvas) => {
    //     const imgData = canvas.toDataURL('image/png');
    //     const pdf = new jsPDF();
    //     pdf.addImage(imgData, 'JPEG', 0, 0);
    //     // pdf.output('dataurlnewwindow');
    //     pdf.save("download.pdf");
    //   })
    // ;
  }
  return (
    <div>
      {props.type == "ROPA" ?
        <RopaForm projects={formdatas} formStateRopa={formState} isUpdate={isUpdate} fileId={fileId}
          scuccessRes={scuccessRes}
          selectedProject={props.selectedProject} /> :
        <>
          <div className="pb-6">
            <span className="text-2xl">
              {"Add " + props.type}
            </span>
            {
              props.type === "ROPA" || props.type === "DSAR Requests" ? <button
                style={{ float: 'right' }}
                onClick={() => printDocument()}
                className="w-36 p-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded ml-1">Print</button>
                :
                null
            }
          </div>
          <br />
          <div className="flex p-8 bg-stone-100" >
            <form onSubmit={handleSubmit} >
              <div className="grid grid-cols-2 gap-6">
                {createClient(props.type).map(item =>

                  <div className="mb-4  flex flex-col items-start" key={item.name}>
                    <label htmlFor={item.name} className="mr-2">{item.title} :</label>
                    {item.type == "select" ?
                      <Select
                        className="select-dd"
                        value={item.options ? formState[item.name] : item.api ? item.name == "tenant_id" ? selectedTenant : selectedOPtion : selectedOPtionSma}
                        onChange={(value) => handleChangeSelect(value, item.name, item.api)}
                        options={item.options ? item.options : item.name == "has_msa" ? sma :
                          item.name == "tenant_id" ? tenantdatas :
                            formdatas}

                      />
                      :
                      <input id={item.name} name={item.name} type={item.type ? item.type : "text"}
                        value={item.type == "date" ? formState[item.name]?.slice(0, -14) : formState[item.name]}
                        onChange={(e) => handleChange(e, item.type)}
                        disabled={isUpdate ? item.disable : false}
                        className="rounded-b-md border border-gray-300 p-2" />
                    }

                  </div>


                )}
              </div>
              {!updateFile && props.isLogo &&
                <div style={{ marginTop: "20px" }}>
                  <div className="flex justify-start" style={{ marginBottom: "10px" }}>Attach  Logo</div>
                  <label htmlFor="contained-button-file">
                    <input accept="image/*" id="contained-button-file" multiple type="file" style={{ display: "none" }}
                      onChange={handleUploadClick} />
                    <span className="upload-span">
                      <div className="p-2 border border-dashed mb-2">add</div>
                    </span>
                  </label>
                </div>
              }
              <div>
                {selectedFile?.name}
              </div>
              {updateFile &&
                <div style={{ display: "flex", margin: "10px" }}>
                  <div style={{ marginRight: 10 }}>{"Logo"}</div>
                  <img className="file-thumbnail" src={updateFile} alt="Retailer icon thumbnail" style={{ height: '5rem', display: 'block' }} />

                  <div onClick={() => setUpdateFile()}><svg className="h-8 w-8 text-red-500 cursor-pointer" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />  <line x1="9" y1="9" x2="15" y2="15" />  <line x1="15" y1="9" x2="9" y2="15" /></svg></div>
                </div>}

              {selectedForm &&
                <div>
                  {props.type == "DSAR Requests" &&
                    <>
                      <div className="time-line-head">Time Line</div>
                      <div className="time-line">
                        <div className="rounded-type">
                          <CheckIcon />
                        </div>
                        <div className="time-line-date">{moment(selectedForm?.created_at).utc().format('YYYY-MM-DD')}  &nbsp; Request Created</div>
                      </div>
                      {
                        selectedForm?.response_date && <>
                          <div className="line-height"></div>
                          <div className="time-line">
                            <div className="rounded-type">
                              <CheckIcon />
                            </div>
                            <div className="time-line-date">{moment(selectedForm?.response_date).utc().format('YYYY-MM-DD')} &nbsp; Request Responded</div>
                          </div>
                        </>
                      }
                    </>}
                </div>
              }
              <button type="submit" className="mt-7 w-64 p-2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-2">Save</button>
            </form>
          </div>
        </>}



      {showError &&
        <div className="flex flex-col justify-center absolute top-1 right-0">
          <div className="bg-red-600 shadow-lg mx-auto w-96 max-w-full text-sm pointer-events-auto bg-clip-padding rounded-lg block mb-3" id="static-example" role="alert" aria-live="assertive" aria-atomic="true" data-mdb-autohide="false">
            <div className="bg-red-600 flex justify-between items-center py-2 px-3 bg-clip-padding border-b border-red-500 rounded-t-lg">
              <p className="font-bold text-white flex items-center">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" className="w-4 h-4 mr-2 fill-current" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path>
                </svg>
                Failed</p>
              <div className="flex items-center">

                <button onClick={() => setShowError(false)} type="button" className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                  <span className="sr-only">Close menu</span>

                  <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="p-3 bg-red-600 rounded-b-lg break-words text-white">
              {errorMessage}
            </div>
          </div>


        </div>
      }
      {isLoading &&
        <Spinner />}
      {modalOpen &&
        <PrintForm
          modalOpen={modalOpen}
          closeModal={closeModal}
          formState={formState}
          title={props.type}
          type={props.type}
          selectedProject={props.selectedProject}
        />
      }

    </div>
  );
}

export default CreateForm;